export default (value: string) => {
  const invalidCharactersRegex = /[^(~`!@#$%^&*()_+=[\]\{}|;'‘’“”:",.\/<>?a-zA-Z0-9-\s)]+/;
  const testResult = !invalidCharactersRegex.test(value); // true if all valid
  let correctValue = '';
  if(!testResult) {
    correctValue = value.replace(invalidCharactersRegex, '');
  }
  return [testResult, correctValue];
};
